const hashName = ({ file, fileKey = "" }) => {
  try {
    if (!file || !file.name) {
      throw new Error("Invalid file object");
    }

    const nameParts = file.name.split(".");
    let extension = "unknown";

    if (nameParts.length > 1 && nameParts[nameParts.length - 1].trim() !== "") {
      extension = nameParts.pop();
    }

    const baseName = nameParts.join(".");

    const timestamp = Date.now();

    const random = Math.random().toString(36).substring(2, 15);

    const baseString =
      timestamp + random + (fileKey ? fileKey + "_" : "") + baseName;

    const safeString = unescape(encodeURIComponent(baseString));

    const hash = btoa(safeString)
      .replace(/[^a-z0-9]/gi, "")
      .toLowerCase();

    return `${hash}.${extension}`;
  } catch (e) {
    console.error("Error generando nombre hash para archivo:", e);
    return `error_${Date.now()}.unknown`;
  }
};

const sanitizeFilename = (name = "") => {
  return name
    .normalize("NFKD") // quita tildes (á → a)
    .replace(/[^a-z0-9_.-]/gi, "_") // reemplaza todo lo que no sea alfanumérico, punto, guion o guion bajo
    .replace(/_+/g, "_") // colapsa guiones bajos múltiples
    .toLowerCase()
    .trim();
};

export { hashName, sanitizeFilename };
